// extracted by mini-css-extract-plugin
export default {"main_container":"SignInBtn_main_container__+aRnV","profil_img":"SignInBtn_profil_img__VTgQB","btnCnx":"SignInBtn_btnCnx__talHm"};